// ActivityRecordingPanel — Admin → Time: the on/off switch for the active-work log
// (docs/ACTIVITY_HUD_PLAN.md). Off until the team has been told.
import { useEffect, useState } from 'react'
import { getActivityRecordingStatus, setActivityRecording } from '../../services/activity.js'
import { confirmDialog } from '../Dialog.jsx'

const font = '"DM Sans", sans-serif'

export default function ActivityRecordingPanel() {
  const [status, setStatus] = useState(null)   // null = loading; { enabled, enabledAt }
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')

  useEffect(() => {
    getActivityRecordingStatus().then(setStatus).catch(e => setErr(e.message))
  }, [])

  async function toggle() {
    const next = !(status && status.enabled)
    if (next) {
      const ok = await confirmDialog({
        title: 'Start recording work activity?',
        message: 'From now on the app records when each signed-in person is actively working, in which tool and on which project. Idle tabs record nothing. Only turn this on once the team has been told.',
        confirmLabel: 'Start recording',
      })
      if (!ok) return
    }
    setBusy(true); setErr('')
    try {
      await setActivityRecording(next)
      setStatus(await getActivityRecordingStatus())
    } catch (e) { setErr(e.message) }
    setBusy(false)
  }

  const on = !!(status && status.enabled)
  return (
    <div style={{ fontFamily: font, fontSize: 13, color: 'var(--aj-text)', padding: '12px 16px 16px' }}>
      <div style={{ color: 'var(--aj-text-mid)', marginBottom: 12, lineHeight: 1.5 }}>
        Records when each person is actively working in the app (typing, clicking, drawing), in which tool
        and on which project. It feeds suggested time entries and the Tower's activity view. Idle tabs record
        nothing, and sessions Claude drives are labelled and left out.
      </div>
      {status === null && !err && <div style={{ color: 'var(--aj-text-muted)' }}>Loading…</div>}
      {status && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{
            padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600,
            background: on ? 'rgba(29,158,117,0.14)' : 'var(--aj-bg-muted)',
            color: on ? '#1D9E75' : 'var(--aj-text-muted)',
          }}>{on ? 'Recording' : 'Off'}</span>
          {on && status.enabledAt && (
            <span style={{ fontFamily: '"DM Mono", monospace', fontSize: 12, color: 'var(--aj-text-muted)' }}>
              since {new Date(status.enabledAt).toLocaleDateString()}
            </span>
          )}
          <button onClick={toggle} disabled={busy} style={{
            marginLeft: 'auto', padding: '6px 14px', borderRadius: 4, cursor: busy ? 'default' : 'pointer',
            fontFamily: font, fontSize: 12, border: '0.5px solid var(--aj-border-mid)',
            background: on ? 'var(--aj-bg-surface)' : '#07272D', color: on ? 'var(--aj-text)' : '#fff',
          }}>{busy ? 'Saving…' : (on ? 'Turn off' : 'Turn on')}</button>
        </div>
      )}
      {err && <div style={{ color: '#c0392b', marginTop: 8 }}>{err}</div>}
    </div>
  )
}
